import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { wikiUi } from './wikiUi';
import { wikiPaths } from './wikiRoutes';

/**
 * `const openAsk = useOpenWikiAsk(); openAsk({ question, autoSend: true })`
 *
 * Hand a question (and optional `categoryId` / `pageId` scope) to Ask and go
 * there — the prototype's `wkAsk(text)` from the Home hero chips, and the
 * "Ask about this …" entry points. With no argument it just opens Ask
 * (`wkGoAsk`). Ask reads the hand-off with `wikiUi.peekAskPrefill()` and
 * clears it with `wikiUi.consumeAskPrefill()`.
 */
export default function useOpenWikiAsk() {
    const navigate = useNavigate();
    return useCallback((prefill) => {
        if (prefill && (prefill.question || prefill.categoryId || prefill.pageId)) wikiUi.setAskPrefill(prefill);
        navigate(wikiPaths.ask());
    }, [navigate]);
}
